import { InjectionToken } from '@angular/core';
import { AppointmentResourcesService } from './appointment.resources.service.interface';
import { AppointmentsService } from './appointments.service.interface';

export const APPOINTMENT_SERVICE = new InjectionToken<AppointmentsService>('');
export const APPOINTMENT_RESOURCES_SERVICE = new InjectionToken<AppointmentResourcesService>('');